import React, { useRef } from 'react'
import { GalleryDialogRef, GalleryItemModel } from './Gallery.model';
import GalleryThumbnail from './GalleryThumbnail';
import GalleryDialog from './GalleryDialog';
import { Typography } from '../Typography/Typography.page';
import GalleryImage from './GalleryImage';
import GallerySlider from './GallerySlider';
import GalleryBigThumbnail from './GalleryBigThumbnail';

type Props = {
    items?: GalleryItemModel[]
    withoutDialog?: boolean
    bigThumbnail?: boolean
}

const Gallery = ({ items, withoutDialog = false, bigThumbnail = false }: Props) => {
    const galleryRef = useRef<GalleryDialogRef>(null)

    if (!items) return (<Typography>-</Typography>)

    if (withoutDialog) {
        return <>
            {
                items?.length === 1 ?
                    <GalleryImage {...items[0]} /> :
                    <GallerySlider items={items} />
            }
        </>
    }

    return (
        <>
            {bigThumbnail ?
                <GalleryBigThumbnail
                    items={items}
                    handleOnClick={(selected) => {
                        if (galleryRef.current) {
                            galleryRef.current.show()
                            galleryRef.current.selected = selected
                        }
                    }}
                /> :
                <GalleryThumbnail
                    items={items}
                    handleOnClick={(selected) => {
                        if (galleryRef.current) {
                            galleryRef.current.show()
                            galleryRef.current.selected = selected
                        }
                    }}
                />}

            <GalleryDialog dialogRef={galleryRef} items={items} />
        </>
    )
}

export default Gallery